import React from 'react'
import withIconStyles from '@edulastic/icons/src/HOC/withIconStyles'
import SVG from '@edulastic/icons/src/common/SVG'

const IconHeader2 = (props) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width="14.419"
    height="13.462"
    viewBox="0 0 14.419 13.462"
    {...props}
  >
    <g transform="translate(-16 -29.578)">
      <path
        d="M10.8,0H8.383V-4.93H3.859V0H1.438V-11.422H3.859v4.477H8.383v-4.477H10.8Z"
        transform="translate(14.563 41)"
      />
      <path
        d="M2.2-4.248a1.6,1.6,0,0,1,.976.268.879.879,0,0,1,.36.748,1.069,1.069,0,0,1-.188.608,2.385,2.385,0,0,1-.444.5q-.256.216-.7.536a5.844,5.844,0,0,0-.808.64H3.12a1.222,1.222,0,0,0,.324-.032.235.235,0,0,0,.148-.1.714.714,0,0,0,.064-.224h.168q0,.944.032,1.352A9.159,9.159,0,0,0,2.664,0H.336V-.152q.1-.112.408-.384.464-.424.772-.756a3.519,3.519,0,0,0,.536-.768,1.935,1.935,0,0,0,.228-.908.871.871,0,0,0-.188-.62.736.736,0,0,0-.556-.2,1.136,1.136,0,0,0-.6.156,1.612,1.612,0,0,0-.476.46l-.136-.08A2.016,2.016,0,0,1,2.2-4.248Z"
        transform="translate(26.563 43)"
      />
    </g>
  </SVG>
)

export default withIconStyles(IconHeader2)
